import { QuestionContainerComponent } from "./games/multiple-choice/question-container/question-container.component";
import { MultipleChoiceComponent } from "./games/multiple-choice/multiple-choice.component";
import { gameReducer } from "./store/reducers/game.reducer";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { GamesComponent } from "./games/games.component";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { HomeComponent } from "./home/home.component";
import { StoreModule } from "@ngrx/store";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { EffectsModule } from "@ngrx/effects";
import { GameEffects } from "./store/effects/game.effects";
import { HttpClientModule } from "@angular/common/http";
import { CommonModule } from "@angular/common";
import { NavBarComponent } from "./nav-bar/nav-bar.component";
import { FormsModule } from "@angular/forms";

@NgModule({
  declarations: [
    AppComponent,
    GamesComponent,
    HomeComponent,
    MultipleChoiceComponent,
    NavBarComponent,
    QuestionContainerComponent,
  ],
  imports: [
    NgbModule,
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    NgbModule.forRoot(),
    StoreModule.forRoot({}),
    StoreModule.forFeature("gameData", gameReducer),
    StoreDevtoolsModule.instrument({ maxAge: 25 }),
    EffectsModule.forRoot([GameEffects]),
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
